export default __webpack_public_path__ + "static/media/filledFilterIcon.40291a38.svg";